import React from "react";
import ModalButton from "../ModalButton";
import { WarningCircleIcon, XIcon } from "@phosphor-icons/react";
import {
  StyledPopup,
  HeadCard,
  Content,
  IconWrap,
  Title,
  Intro,
} from "../MarcaBlancaRequirementsModal/styles";
import { ButtonsRow } from "./styles";

type Props = {
  open: boolean;
  color: string;
  title: string;
  message: string;
  goToCartLabel: string;
  closeLabel: string;
  onClose: () => void;
  onGoToCart: () => void;
};

const MarcaBlancaCartLimitModal: React.FC<Props> = ({
  open,
  color,
  title,
  message,
  goToCartLabel,
  closeLabel,
  onClose,
  onGoToCart,
}) => {
  return (
    <StyledPopup
      open={open}
      modal
      closeOnDocumentClick={false}
      closeOnEscape={false}
      onClose={() => undefined}
    >
      <div className="container">
        <HeadCard>
          <XIcon
            size={24}
            color="#999999"
            style={{ cursor: "pointer" }}
            onClick={onClose}
          />
        </HeadCard>

        <Content>
          <IconWrap>
            <WarningCircleIcon size={56} weight="regular" color="#F5C518" />
          </IconWrap>
          <Title>{title}</Title>
          <Intro style={{ fontSize: "15px" }}>{message}</Intro>
        </Content>

        <ButtonsRow>
          <ModalButton color={color} secondary={false} onClick={onGoToCart}>
            {goToCartLabel}
          </ModalButton>
          <ModalButton color={color} secondary={true} onClick={onClose}>
            {closeLabel}
          </ModalButton>
        </ButtonsRow>
      </div>
    </StyledPopup>
  );
};

export default MarcaBlancaCartLimitModal;
